import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Flip,
  Front,
  Back,
  Feather,
  Name,
  Description,
  TitleContainer
} from './styled';

const ValueCard = ({
  name,
  frontBg,
  backBg,
  id,
  length,
  description,
  flipCard,
  flippedCardId,
  inView,
  marginRight,
  cardWidth,
  activeCardIndex
}) => {
  useEffect(() => {
    if (activeCardIndex === 0 && inView) {
      setTimeout(() => {
        flipCard(1);
      }, 600);
    } else if (!inView) {
      flipCard(0);
    }
  }, [inView]);

  return (
    <Card onClick={() => flipCard(id)} marginRight={marginRight} cardWidth={cardWidth}>
      <Flip
        animate={{ rotateY: flippedCardId === id ? 180 : 0 }}
        transition={{
          type: 'spring',
          mass: 2.9,
          damping: 21
        }}
      >
        <Front frontBg={frontBg}>
          <Feather />
          <Name>{name}</Name>
        </Front>

        <Back backBg={backBg}>
          <TitleContainer>
            <span>
              {id}/{length}
            </span>
            <h3>{name}</h3>
          </TitleContainer>
          <Description>{description}</Description>
        </Back>
      </Flip>
    </Card>
  );
};

export default ValueCard;

ValueCard.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  frontBg: PropTypes.string.isRequired,
  backBg: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  length: PropTypes.number.isRequired,
  flipCard: PropTypes.func.isRequired,
  flippedCardId: PropTypes.number.isRequired,
  inView: PropTypes.bool.isRequired,
  marginRight: PropTypes.number.isRequired,
  cardWidth: PropTypes.number.isRequired,
  activeCardIndex: PropTypes.number.isRequired
};
